
import { request } from "../../../config/helpers/axios-instance";
import { useQuery } from "react-query";
import { DELIVERY_TAB_STATUS_FILTER, DELIVERY_TABS } from "../../../components/delivery/constants";


const fetchDeliveries = (page, size, search, tab = DELIVERY_TABS.NEW) => {
    const statusFilter = DELIVERY_TAB_STATUS_FILTER[tab] || DELIVERY_TAB_STATUS_FILTER[DELIVERY_TABS.NEW];

    return useQuery(
        ["get-all-deliveries", page, size, search, tab],
        () =>
            request({
                url: `delivery`,
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                params: search.length > 0 ? {
                    page: page,
                    size: size,
                    status: statusFilter,
                    patientName: search,
                    userName: search,
                } : {
                    page: page,
                    size: size,
                    status: statusFilter,
                },
            })

    );
}



export { fetchDeliveries };



